import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import ButtonInc from "../../../../shared-ui/ButtonInc";

const CancellationActionDialog = (props) => {
  const { open, onClose, onConfirm, actionType, loading } = props;
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {actionType === "Approved" ? "Approve" : "Reject"} Cancellation Request
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Reason"
          type="text"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions>
        <ButtonInc onClick={handleClose} disabled={loading}>
          Cancel
        </ButtonInc>
        <ButtonInc
          onClick={handleConfirm}
          variant="contained"
          disabled={!reason.trim() || loading}
          style={{
            background: actionType === "Approved" ? "#4CAF50" : "#f44336",
            color: "#fff",
          }}
        >
          {loading ? "Processing..." : actionType === "Approved" ? "Approve" : "Reject"}
        </ButtonInc>
      </DialogActions>
    </Dialog>
  );
};

export default CancellationActionDialog;
